var websiteName = "astrazeneca";
var cards = document.querySelectorAll("a");
var modal = document.getElementById("redirectModal");

for (var i = 0; i < cards.length; i++) {
    var card = cards[i];
    card.onclick = function () {
        if(!this.toLocaleString().includes(websiteName)
            && !this.toLocaleString().includes("storyblok")
            && !this.toLocaleString().includes("atemwege")
            && !this.toLocaleString().includes("mailto")
            && !this.toLocaleString().includes("eigenart")
            && !this.toLocaleString().includes("onkologie-mit-mut")
            && !this.toLocaleString().includes("lupus-leben")
            && !this.toLocaleString().includes("mamableibgesund")
            && !this.toLocaleString().includes("krebsbegleiter")
            && !document.getElementById("redirectModal").classList.contains("modal-open")
            && !this.toLocaleString().includes("cookie")
            && !this.classList.contains("redirectButton"))
        {
            modal.style.display = "block"; //open modal
            document.getElementById("continueButtonRedirectModal").setAttribute("href", this.toLocaleString()); //setting the redirect link
            document.getElementById("redirectModal").classList.add("modal-open");
            return false; //override standard handling
        }
    }
}

// Get elements that closes the modal
var span = document.getElementsByClassName("redirect-modal-close")[0];
var cancelButton = document.getElementById("cancelButtonRedirectModal");

// When the user clicks, close the modal
if(span!=null){
    span.onclick = function (){
        closeModal();
        return false; //override standard handling
    }
}
if(cancelButton!=null) {
    cancelButton.onclick = function () {
        closeModal();
        return false; //override standard handling
    }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
        document.getElementById("redirectModal").classList.remove("modal-open");
    }
}

function closeModal(){
    modal.style.display = "none";
    document.getElementById("redirectModal").classList.remove("modal-open");
}

